import { Account } from 'src/api/@generated/backend';

import { selectRequestDataOrThrow } from 'src/state/request/selectors';
import { RequestType } from 'src/state/request/types';
import { RootState } from 'src/state/types';
import { getOrThrow } from 'src/utils/type-utils';

export const selectAccounts = (state: RootState): Account[] =>
  selectRequestDataOrThrow<Account[]>(RequestType.GET_ACCOUNTS)(state);

export const selectSelectedAccountOrThrow = (state: RootState): Account => {
  const selectedAccount = selectSelectedAccount(state);

  return getOrThrow(selectedAccount, 'Account is not selected');
};

export const selectSelectedAccount = (state: RootState): Account | undefined => {
  const idx = selectSelectedAccountIdx(state);

  if (idx === undefined) {
    return undefined;
  }

  return selectAccounts(state)[idx];
};

export const selectHasAccountBeenSelected = (state: RootState): boolean =>
  state.account.selectedAccountIdx !== undefined;

export const selectSelectedAccountIdx = (state: RootState): number | undefined => state.account.selectedAccountIdx;

export const selectHasNoAccounts = (state: RootState): boolean => selectAccounts(state).length === 0;

export const selectHasOnlyOneAccount = (state: RootState): boolean => selectAccounts(state).length === 1;
